import React, { useEffect, useState } from "react";
import "../../css/pages/smallContentDisplay.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { iContent } from "./ContentShow";
import { NavLink } from "react-router-dom";
import { useGetPosts } from "../../queries";

interface Props {
  category: string;
}

const SmallContentDisplay: React.FC<Props> = (Props) => {
  const [typedText, setTypedText] = useState("");
  const [initialIndex, setInitialIndex] = useState(0);
  const [resetTimer, setResetTimer] = useState(false);

  const { data: contents, isLoading: postsLoading } = useGetPosts();

  const links = contents?.map((value: iContent) => ({
    title: value?.title,
    url: `/${Props?.category}/${value?.id}`,
  }));

  // Typewriter effect
  useEffect(() => {
    if (!links || links?.length === 0) return; // Check if links are available

    let i = 0;
    const current = links[initialIndex];
    setTypedText(""); // clear old text

    const effectInterval = setInterval(() => {
      if (i <= current.title.length) {
        setTypedText(current.title.substring(0, i));
        i++;
      }
    }, 75);

    return () => clearInterval(effectInterval);
  }, [links?.length, initialIndex]);

  // Auto change content every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      if (!resetTimer) {
        setInitialIndex((prev) => (prev + 1) % links.length);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [links?.length, resetTimer]);

  const handleClickNext = () => {
    setInitialIndex((prev) => (prev + 1) % links.length);
    setResetTimer(true);
    resetAutoChangeTimer();
  };

  const handleClickPrevious = () => {
    setInitialIndex((prev) => (prev === 0 ? links.length - 1 : prev - 1));
    setResetTimer(true);
    resetAutoChangeTimer();
  };

  const resetAutoChangeTimer = () => {
    setTimeout(() => {
      setResetTimer(false);
    }, 5000);
  };

  return (
    <div className="scdContainer">
      <button>آخرین مطالب</button>
      <div className="scdLeftSide">
        <div className="scdText">
          <NavLink className="navLink" to={links?.[initialIndex]?.url || ""}>
            {typedText}
            <span className="caret" />
          </NavLink>
        </div>

        <div className="scdNavigationIcons">
          <div className="arrowContainer" onClick={handleClickNext}>
            <ArrowBackIosIcon fontSize="small" />
          </div>
          <div className="arrowContainer" onClick={handleClickPrevious}>
            <ArrowForwardIosIcon fontSize="small" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmallContentDisplay;
